import { ReadingListArticle } from '../../../models/ReadingListArticle';
import { TagDto } from '../../../services/dtos/tags/tag.dto';
import { ReadingListArticleDto } from '../../../services/dtos/readingList/readingListArticle.dto';
import { getCompanies } from '../../../utils/tagUtils';
import { getArticleTypeName } from '../../articles/utils/article.mappers';
import { mapTagsIdsToTags } from '../../tags/utils/tags.mappers';

export const mapReadingListArticleDtoToReadingListArticle = (
  readingListArticles: ReadingListArticleDto[],
  tags: Record<string, TagDto>
): Map<number, ReadingListArticle> =>
  new Map(
    readingListArticles.map((article) => {
      const articleTags = mapTagsIdsToTags(article.tags, tags);

      return [
        article.articleId,
        {
          id: article.id,
          articleId: article.articleId,
          articleType: getArticleTypeName(articleTags),
          companies: getCompanies(articleTags),
          title: article.title,
          bookmarkedAt: article.bookmarkedAt,
          publishDate: article.publishDate,
        },
      ];
    })
  );
